<template>
  <div>
    <div class="index-bg">
      <div class="logo-bar">
        <div class="logo">
          <img src="../../assets/logo.png" alt="" />
        </div>
        <div class="logo-name">
          <img src="../../assets/logo_name.png" alt="" />
        </div>
      </div>
      <div class="index-content">
        <div class="index-fun-body">
          <div class="carousel">
            <!-- <img :src="images[currentIndex]" alt="Carousel Image" /> -->
            <img :src="image" v-show="index == currentIndex" v-for="(image, index) in images" :key="index" />
          </div>
          <div class="fun-dots">
            <div class="dot" v-for="(image, index) in images" :key="index"
              :class="{'dot-seletced': index == currentIndex}"></div>
          </div>
        </div>
        <div class="login-body">
          <div class="login-title">
            请使用<label>手机号码</label>登录
          </div>
          <div class="input-body">
            <div class="input-photo">
              <input type="number" v-model="formData.mobile" @input="limitMobile" placeholder="手机号">
            </div>
            <div class="input-sms">
              <input type="number" v-model="formData.sms_code" @input="limitSmsCode" placeholder="短信验证码">
              <div class="sms-btn" :class="{'sms-btn-click':isCountingDown}" @click="getSmsCode()">
                {{ isCountingDown ? `${countdown}s 后重新获取` : '获取短信验证码' }}
              </div>
            </div>
          </div>
          <div class="login-btn" @click="submitLogic">登录</div>
          <div class="privacy">
            <div class="privacy-check" @click="rePrivacy">
              <img src="@/assets/ic_selected_y.png" v-if="rePrivacySelected" />
              <img src="@/assets/ic_selected_n.png" v-else />
            </div>
            登录表示您已阅读并同意
            <label @click="clickTerm(1)">服条协议</label>
            <span>和</span>
            <label @click="clickTerm(2)">隐私政策</label>
          </div>
        </div>
      </div>
    </div>
    <div class="banner-bg">
      <img src="../../assets/bg_banner.png" alt="" />
    </div>
    <div class="banner-bg">
      <img src="../../assets/bg_banner1.png" alt="" />
    </div>
    <div class="banner-bg">
      <img src="../../assets/bg_banner2.png" alt="" />
    </div>
    <div class="banner-bg">
      <img src="../../assets/bg_banner3.png" alt="" />
    </div>
    <div class="copyright">
      Copyright © 2024 深圳市寻讯科技有限公司 版权所有 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer"> 粤ICP备2024291999号</a>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  import { common, sendCode, login } from '@/utils/api/apis'
  import FingerprintJS from '@fingerprintjs/fingerprintjs';
  import { LocalStorageKeys } from '@/utils/local_storage';
  import { setUserInfo } from '@/utils/oss.js';
  import { rsaEncryptWithPublicKey } from '@/utils/sign_utils.js';
  import { mapState } from 'vuex'
  export default {
    // import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      // 这里存放数据
      return {
        images: [
          require('@/assets/fun_item1.png'),
          require('@/assets/fun_item2.png'),
          require('@/assets/fun_item3.png')
        ],
        currentIndex: 0,
        formData: {
          mobile: '',
          sms_code: '',
          device_id: ''
        },
        countdown: 60,            // 倒计时总秒数
        isCountingDown: false,    // 倒计时状态
        intervalId: null,         // 定时器 ID
        rePrivacySelected: false,
      }
    },
    // 过滤器
    filters: {},
    // 监听属性 类似于data概念
    computed: {
      ...mapState('common', {
        commonData: state => state.commonData
      })
    },
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      clickTerm(type) {
        if (type == 1) {
          window.open(this.commonData.agreement.service, '_blank');
        } else {
          window.open(this.commonData.agreement.privacy, '_blank');
        }
      },
      limitMobile() {
        if (this.formData.mobile.length > 11) {
          this.formData.mobile = this.formData.mobile.slice(0, 11); // 只保留前11个字符
        }
      },
      limitSmsCode() {
        if (this.formData.sms_code.length > 6) {
          this.formData.sms_code = this.formData.sms_code.slice(0, 6); // 只保留前11个字符
        }
      },
      validateMobile(value) {
        const trimmedMobile = this.formData.mobile.replace(/\s+/g, '');
        const mobilePattern = /^1[3-9]\d{9}$/;
        return mobilePattern.test(value);
      },
      async getSmsCode() {
        if (this.isCountingDown) return;
        if (!this.validateMobile(this.formData.mobile)) {
          this.$toast('手机号码不正确');
          return;
        }
        try{
          await sendCode({
            mobile: this.formData.mobile,
            scene: 'login'
          });
          this.startCountdown()
        }catch(e){
          this.$toast(e)
          this.$errorLog('login_page/getSmsCode', e)
        }
      },
      startCountdown() {
        // 如果已经在倒计时中，直接返回
        if (this.isCountingDown) return;

        this.isCountingDown = true;
        this.countdown = 60; // 重置倒计时
        this.intervalId = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--; // 每秒减1
          } else {
            this.resetCountdown(); // 倒计时结束，重置状态
          }
        }, 1000);

        // 此处可以调用获取验证码的接口逻辑
      },
      resetCountdown() {
        clearInterval(this.intervalId); // 清除定时器
        this.isCountingDown = false; // 允许重新点击
        this.countdown = 60; // 重置倒计时
      },
      async submitLogic() {
        if (!this.rePrivacySelected) {
          this.$toast('请阅读并同意服务协议和隐私政策');
          return;
        }
        if (!this.validateMobile(this.formData.mobile)) {
          this.$toast('手机号码不正确');
          return;
        }
        if (this.formData.sms_code.length < 6) {
          this.$toast('验证码不正确');
          return;
        }
        try{
          var base = await login(this.formData);
          setUserInfo(base.data);
          var userInfoEn = await rsaEncryptWithPublicKey(JSON.stringify(base.data));
          this.$localStorage.set(LocalStorageKeys.USER_INFO, userInfoEn);
          this.$router.replace('/');
        }catch(e){
          this.$toast(e)
          this.$errorLog('login_page/submitLogic', e)
        }
      },
      rePrivacy() {
        this.rePrivacySelected = !this.rePrivacySelected
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
      }, 3000);
      FingerprintJS.load().then(fp => {
        fp.get().then(result => {
          this.formData.device_id = result.visitorId;
        });
      });
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {
      // 组件销毁前清除定时器
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    ctivated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='scss' scoped>
  .index-bg {
    background-image: url('../../assets/bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    width: 100vw;
    height: 100vh;

    .logo-bar {
      display: flex;
      align-items: center;
      padding-top: 40px;
      margin-left: 120px;

      .logo {
        img {
          width: 30px;
          height: 30px;
        }
      }

      .logo-name {
        margin-left: 10px;

        img {
          width: 103px;
          height: 24px;
        }
      }
    }

    .index-content {
      /* padding: 0 335px; */
      margin-top: 100px;
      display: flex;
      align-items: center;
      justify-content: center;

      .index-fun-body {
        .carousel {
          width: 520px;
          height: 648px;

          img {
            width: 520px;
            height: 648px;
          }
        }

        .fun-dots {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 38px;

          .dot {
            width: 10px;
            height: 10px;
            background-color: white;
            margin: 0 18px;
            border-radius: 10px;
          }

          .dot-seletced {
            background-color: #4A83FF;
          }
        }
      }

      .login-body {
        width: 560px;
        background-color: white;
        border-radius: 24px;
        margin-left: 170px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        padding: 50px 0px;

        .login-title {
          font-size: 22px;
          font-weight: bold;
          color: #000;

          label {
            color: #4A83FF;
          }
        }

        .input-body {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          margin-top: 40px;

          .input-photo {
            width: 326px;
            height: 48px;
            margin-bottom: 20px;
            border: 1px solid #E5E7EE;
            border-radius: 10px;
            padding: 0 20px;

            input {
              width: 100%;
              height: 100%;
              border: none;
              outline: none;
            }
          }

          .input-sms {
            width: 326px;
            height: 48px;
            border: 1px solid #E5E7EE;
            border-radius: 10px;
            padding: 0 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            input {
              height: 100%;
              border: none;
              outline: none;
            }

            .sms-btn {
              width: 120px;
              font-size: 16px;
              color: #4A83FF;
              text-align: right;
            }
            .sms-btn-click {
              color: #B3B3B3;
            }

            .sms-btn:hover {
              cursor: pointer;
            }
          }
        }

        .login-btn {
          width: 366px;
          height: 56px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 40px;
          background-color: #4A83FF;
          color: white;
          font-size: 18px;
          font-weight: bold;
          border-radius: 14px;
        }

        .login-btn:hover {
          cursor: pointer;
        }

        .privacy {
          margin-top: 68px;
          color: #B3B3B3;
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          .privacy-check:hover {
            cursor: pointer;
          }
          .privacy-check {
            width: 18px;
            height: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 6px;
            img {
              width: 18px;
              height: 18px;
            }
          }
          label:hover {
            cursor: pointer;
          }
          label {
            margin-left: 4px;
          }
          span {
            margin-left: 4px;
          }
        }
      }
    }
  }

  .banner-bg {
    width: 100vw;
    background-size: cover;

    img {
      width: 100vw;
      background-size: cover;
    }
  }
  .copyright {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    height: 30px;
    color: #999;
    a {
      margin-left: 4px;
      color: #999;
      text-decoration: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/content/login/login_page.vue